/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_minecraft_mode_legacy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legacy Offline Save Compatibility`)
};

const zh_hans1_settings_minecraft_mode_legacy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保留离线历史存档兼容`)
};

const zh_hant1_settings_minecraft_mode_legacy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保留離線歷史存檔相容`)
};

const fr_settings_minecraft_mode_legacy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatibilité des sauvegardes hors ligne`)
};

const de_settings_minecraft_mode_legacy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legacy-Offline-Kompatibilität`)
};

const ja_settings_minecraft_mode_legacy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レガシーオフライン互換モード`)
};

const ko_settings_minecraft_mode_legacy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기존 오프라인 세이브 호환 모드`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_minecraft_mode_legacy = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_minecraft_mode_legacy(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_minecraft_mode_legacy", locale)
	if (locale === "en") return en_settings_minecraft_mode_legacy(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_minecraft_mode_legacy(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_minecraft_mode_legacy(inputs)
	if (locale === "fr") return fr_settings_minecraft_mode_legacy(inputs)
	if (locale === "de") return de_settings_minecraft_mode_legacy(inputs)
	if (locale === "ja") return ja_settings_minecraft_mode_legacy(inputs)
	return ko_settings_minecraft_mode_legacy(inputs)
};